import styled, { css } from 'styled-components'

export const SC_CircleDecor = styled.div.attrs(props => ({
  
}))`
	position: absolute;
	left: -${props => (props.width)/4}px;
	top: -${props => (props.width)/2}px;
	pointer-events: none;
	width: ${props => props.width}px;
	height: ${props => props.width}px;
	border: 20px solid ${props => props.theme.ymcaRedDark};
	border-radius: 50%;
	opacity: .2;
`